export enum WorkspacePermission {
  Member = 'member',
  Collaborator = 'collaborator',
  Owner = 'owner',
}
